import axios from 'axios';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { API_PREFIX_URL, CACHE_KEYS } from './config';

const getCampaignResults = async (campaignIdentifier) => {
  const { data } = await axios.get(
    `${API_PREFIX_URL}/campaigns/${campaignIdentifier}/campaign_results`
  );
  return data;
};

export const useCampaignResults = (campaignIdentifier, refetchEnabled = true) =>
  useQuery(
    [CACHE_KEYS.CAMPAIGN_RESULTS, campaignIdentifier],
    () => getCampaignResults(campaignIdentifier),
    {
      enabled: !!campaignIdentifier,
      staleTime: refetchEnabled ? 1000 * 60 * 5 : Infinity,
      refetchOnWindowFocus: refetchEnabled,
    }
  );

const create = async (campaignIdentifier) => {
  const { data } = await axios.post(
    `/insights_platform/campaigns/${campaignIdentifier}/create_campaign_result`
  );
  return data;
};

/*
 *  Add share result
 */
export const useCreateCampaignResult = (campaignIdentifier) => {
  const queryClient = useQueryClient();
  return useMutation(() => create(campaignIdentifier), {
    onSuccess: () => {
      queryClient.invalidateQueries([
        CACHE_KEYS.CAMPAIGN_RESULTS,
        campaignIdentifier,
      ]);
    },
  });
};

const destroy = async (campaignResultIdentifier) => {
  await axios.delete(
    `/insights_platform/campaign_results/${campaignResultIdentifier}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

/*
 *  Destroy share result
 */

export const useDestroyCampaignResult = (campaignIdentifier) => {
  const queryClient = useQueryClient();
  return useMutation(destroy, {
    onSuccess: () => {
      queryClient.invalidateQueries([
        CACHE_KEYS.CAMPAIGN_RESULTS,
        campaignIdentifier,
      ]);
    },
  });
};

export const getResultsData = async (identifier) => {
  const { data } = await axios.get(
    `${API_PREFIX_URL}/campaigns/${identifier}/survey_results`
  );
  return data;
};

export const getCrossTabData = async (
  identifier,
  primaryQuestionId,
  secondaryQuestionId
) => {
  const { data } = await axios.get(
    `${API_PREFIX_URL}/results/${identifier}/cross_tab_data?primary_question_id=${primaryQuestionId}&secondary_question_id=${secondaryQuestionId}`
  );
  return data;
};
